import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLearner } from '../learners/LearnerContext';
import { useSettings } from '../settings/SettingsContext';
import { useT } from '../i18n/i18n';
import { fetchPreference } from './preferences';

export default function PreferencePrompt() {
  const t = useT();
  const { settings } = useSettings();
  const { learners, learnerId } = useLearner();
  const [needed, setNeeded] = useState(false);
  const enabled = settings.features.preferenceAssessment;

  useEffect(() => {
    let cancelled = false;
    setNeeded(false);
    if (!enabled || !learnerId) return;
    fetchPreference(learnerId)
      .then((p) => { if (!cancelled) setNeeded(p.ranking.length === 0 && p.choices.length >= 2); })
      .catch(() => undefined);
    return () => { cancelled = true; };
  }, [enabled, learnerId]);

  if (!needed) return null;
  const name = learners.find((l) => l.id === learnerId)?.name;

  return (
    <section className="banner preference-prompt" aria-labelledby="preference-prompt-h">
      <h2 id="preference-prompt-h">{name ? t('Find out which rewards {learner} likes most', { learner: name }) : t('Find out which rewards your learner likes most')}</h2>
      <p>{t('A short activity where the learner picks their favourites, so you can offer the reward that works best.')}</p>
      <div className="toolbar">
        <Link className="btn" to="/preferences">{t('Do it now')}</Link>
      </div>
    </section>
  );
}
